<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.cadastro.estado"
        ref="RkmDataTable"
    />
</template>

<script>
export default {
    computed: {
        fields() {
            return [
                {key: 'pais_nome', label: 'País', name: 'cadastro_pais.nome', searchable: true, sortable: true},
                {key: 'estado_nome', label: 'Nome', name: 'cadastro_estado.nome', searchable: true, sortable: true},
                {key: 'estado_uf', label: 'Sigla', name: 'cadastro_estado.uf', searchable: true, sortable: true},
            ]
        },
    },
    inject: ['repositories'],
}
</script>